import React from "react";

import encryptionvsyou from '../../../assets/images/encryption-vs-you.png';
import bannerThub from '../../../assets/images/banner-thub-new.png';
import CTLogo from '../../../assets/images/CT-Logo.png';


function KnowledgeBanner() {
  return (
    <> 
       <div className="CT-banner">
            <img src={CTLogo} alt="CT Logo" className="CT-logo" />
            <div className="encryptionvsyou-img">The Encryption Battlefield</div>
            <h3>Leverage Metadata and AI for Real World Intelligence</h3>
        </div>     
    </>
  );
};
export default KnowledgeBanner;